<template>
  <div
    v-if="goals || dailyQuote"
    class="relative mb-3 overflow-hidden rounded-xl bg-[#3374e4] text-white shadow-md shadow-[#3374e4]/20 fadeIn"
  >
    <div class="absolute inset-0 z-0">
      <Grainient
        color1="#5b9dff"
        color2="#3374e4"
        color3="#14307a"
        :time-speed="0.5"
        :color-balance="0.0"
        :warp-strength="1.0"
        :warp-frequency="5.0"
        :warp-speed="2.0"
        :warp-amplitude="50.0"
        :blend-angle="0.0"
        :blend-softness="0.05"
      />
    </div>
    <div class="relative z-10 flex items-center gap-4 px-5 py-4">
      <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white/15 backdrop-blur-md">
        <Target class="h-5 w-5" />
      </div>
      <div class="min-w-0 flex-1">
        <template v-if="goals">
        <p class="flex flex-wrap items-center gap-x-1.5 text-[11px] text-white/70">
          <span class="font-medium uppercase tracking-wider text-white/90">Your goal</span>
          <template v-if="committedAt">
            <span aria-hidden="true">·</span>
            <span :title="format(committedAt, 'PPpp')">
              Committed {{ format(committedAt, 'MMM d, yyyy') }}
            </span>
          </template>
        </p>
        <p class="mt-0.5 truncate text-base font-light md:text-lg" :title="goals">{{ goals }}</p>
        </template>
        <p
          v-if="dailyQuote"
          class="flex gap-1.5 italic"
          :class="goals ? 'mt-0.5 text-xs text-white/65' : 'text-sm font-light text-white/90 md:text-base'"
          :title="dailyQuote"
        >
          <span
            class="shrink-0 font-serif not-italic leading-none text-[#bffe78]/80"
            :class="goals ? 'text-xl' : 'text-2xl'"
            aria-hidden="true"
          >“</span>
          <span class="truncate">{{ dailyQuote }}</span>
        </p>
      </div>
      <a
        href="https://campus.outtalent.com/goals"
        target="_blank"
        rel="noopener"
        class="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-white/15 px-4 py-1.5 text-xs font-medium backdrop-blur-md transition-all hover:-translate-y-0.5 hover:bg-white/25"
      >
        <template v-if="goals">
          Edit
          <ExternalLink class="h-3.5 w-3.5" />
        </template>
        <template v-else>
          Set personal goal
          <ArrowRight class="h-3.5 w-3.5" />
        </template>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { format } from 'date-fns'
import { ArrowRight, ExternalLink, Target } from 'lucide-vue-next'
import Grainient from '@/components/landing/Grainient.vue'
import api from '@/utils/api'
import { API_ROUTES } from '@/const/apiRoutes'

const goals = ref('')
const updatedAt = ref<string | null>(null)
const dailyQuote = ref('')
const committedAt = computed(() => (updatedAt.value ? new Date(updatedAt.value) : null))

onMounted(async () => {
  try {
    const response = await api.get<{
      program_goals: string
      program_goals_updated_at: string | null
      daily_quote: string
    }>(API_ROUTES.MY_PROGRAM_GOALS)
    goals.value = response.data.program_goals
    updatedAt.value = response.data.program_goals_updated_at
    dailyQuote.value = response.data.daily_quote
  } catch {
    // No FellowData row (404) or transient failure: the reminder simply stays hidden.
  }
})
</script>
